import { File } from "../classes/File.js";
export const channelWebhookHydration = {
    keyMapping: {
        id: "id",
        name: "name",
        avatar: "avatar",
        channel_id: "channelId",
        token: "token",
    },
    functions: {
        id: (webhook) => webhook.id,
        name: (webhook) => webhook.name,
        avatar: (webhook, ctx) => webhook.avatar ? new File(ctx, webhook.avatar) : undefined,
        channelId: (webhook) => webhook.channel_id,
        token: (webhook) => webhook.token,
    },
    initialHydration: () => ({}),
};
